module.exports = __webpack_public_path__ + "static/media/1@3x.1ebb2dac.png";